/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { ColorFields, Color } from 'src/app/app-data/models/Color';
import { DefaultSplitDataRenderType } from '@touchplan/common';

export class ColorList extends FancyFirebaseSplitDataList<ColorFields, DefaultSplitDataRenderType, Color> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const color = new Color(action.payload.key);
		color.databaseUpdate(action.payload.val());
		return color;
	}
}
